<div class="modal-header">
  <h4 class="modal-title pull-left">{{'GLOBAL.PROJET' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="nomProjet">{{'GLOBAL.NOM' | translate}}</label>
      <input id="nomProjet" type="text" [(ngModel)]="projet.nom" name="nomProjet" class="form-control" placeholder="{{'GLOBAL.NOM' | translate}}" (keyup)="nomInvalide = false;"
        maxlength="256" autocomplete="off" />
        @if (nomInvalide) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
        }
      </div>
      <div class="form-group">
        <label>{{'MODALE_PROJET.DATE_DEB_PREV' | translate}}</label>
        <div class="input-group">
          <input placeholder="{{'MODALE_PROJET.DATE_DEB_PREV' | translate}}"
            type="text"
            class="form-control"
            [(ngModel)]="projet.dateDebutPrevisionnelle"
            name="dateDebPrev"
            [matDatepicker]="dateDebPrevPicker"
            onkeydown="return false"
            (click)="dateDebPrevPicker.open()"
            (focus)="dateDebPrevPicker.open()"
            readonly
            autocomplete="off">
            <mat-datepicker #dateDebPrevPicker></mat-datepicker>
            @if (projet.dateDebutPrevisionnelle) {
              <div class="input-group-prepend">
                <button type="button" class="btn btn-outline-primary" (click)="nettoyerDates('dateDebutPrevisionnelle')"><i class="fas fa-eraser"></i></button>
              </div>
            }
          </div>
          @if (datePrevDebInvalide) {
            <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
          }
        </div>
        <div class="form-group">
          <label>{{'MODALE_PROJET.DATE_FIN_PREV' | translate}}</label>
          <div class="input-group">
            <input placeholder="{{'MODALE_PROJET.DATE_FIN_PREV' | translate}}"
              type="text"
              class="form-control"
              [(ngModel)]="projet.dateFinPrevisionnelle"
              name="dateFinPrev"
              [matDatepicker]="dateFinPrevPicker"
              onkeydown="return false"
              (click)="dateFinPrevPicker.open()"
              (focus)="dateFinPrevPicker.open()"
              readonly
              autocomplete="off">
              <mat-datepicker #dateFinPrevPicker></mat-datepicker>
              @if (projet.dateFinPrevisionnelle) {
                <div class="input-group-prepend">
                  <button type="button" class="btn btn-outline-primary" (click)="nettoyerDates('dateFinPrevisionnelle')"><i class="fas fa-eraser"></i></button>
                </div>
              }
            </div>
            @if (datePrevFinInvalide) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
            }
            @if (datesPrevNonChonologiques) {
              <div class="custom-alert custom-alert-sm">{{'MODALE_PROJET.DATE_NON_CHRONO' | translate}}</div>
            }
          </div>
          <div class="form-group">
            <label>{{'MODALE_PROJET.DATE_DEB_EFF' | translate}}@if (!estModif) {
              <small class="text-muted"> - {{'GLOBAL.OPTIONNEL' | translate}}</small>
            }</label>
            <div class="input-group">
              <input placeholder="{{'MODALE_PROJET.DATE_DEB_EFF' | translate}}"
                type="text"
                class="form-control"
                [(ngModel)]="projet.dateDebutEffective"
                name="dateDebEff"
                [matDatepicker]="dateDebEffPicker"
                onkeydown="return false"
                (click)="dateDebEffPicker.open()"
                (focus)="dateDebEffPicker.open()"
                readonly
                autocomplete="off">
                <mat-datepicker #dateDebEffPicker></mat-datepicker>
                @if (projet.dateDebutEffective) {
                  <div class="input-group-prepend">
                    <button type="button" class="btn btn-outline-primary" (click)="nettoyerDates('dateDebutEffective')"><i class="fas fa-eraser"></i></button>
                  </div>
                }
              </div>
              @if (dateEffDebSupTirs) {
                <div class="custom-alert custom-alert-sm">{{dateEffDebSupTirs}}</div>
              }
            </div>
            <div class="form-group">
              <label>{{'MODALE_PROJET.DATE_FIN_EFF' | translate}}@if (!estModif) {
                <small class="text-muted"> - {{'GLOBAL.OPTIONNEL' | translate}}</small>
              }</label>
              <div class="input-group">
                <input placeholder="{{'MODALE_PROJET.DATE_FIN_EFF' | translate}}"
                  type="text"
                  class="form-control"
                  [(ngModel)]="projet.dateFinEffective"
                  name="dateFinEff"
                  [matDatepicker]="dateFinEffPicker"
                  onkeydown="return false"
                  (click)="dateFinEffPicker.open()"
                  (focus)="dateFinEffPicker.open()"
                  readonly
                  autocomplete="off">
                  <mat-datepicker #dateFinEffPicker></mat-datepicker>
                  @if (projet.dateFinEffective) {
                    <div class="input-group-prepend">
                      <button type="button" class="btn btn-outline-primary" (click)="nettoyerDates('dateFinEffective')"><i class="fas fa-eraser"></i></button>
                    </div>
                  }
                </div>
                @if (dateEffFinInvalide) {
                  <div class="custom-alert custom-alert-sm">{{'MODALE_PROJET.DATE_PREV_INVALIDE' | translate}}</div>
                }
                @if (datesEffNonChonologiques) {
                  <div class="custom-alert custom-alert-sm">{{'MODALE_PROJET.DATE_NON_CHRONO' | translate}}</div>
                }
                @if (dateEffFinInfTirs) {
                  <div class="custom-alert custom-alert-sm">{{dateEffFinInfTirs}}</div>
                }
              </div>
              <div class="form-group">
                <label for="selectWorkflow">{{'GLOBAL.WORKFLOW' | translate}}</label>
                @if (estModif) {
                  <div>
                    <label style="font-size: 0.8rem;">
                      Workflow courant : {{projet?.workflowModeleProjet?.nom}} {{(projet?.workflowModeleProjet?.dateDerniereModification ? ('(' + (projet.workflowModeleProjet.dateDerniereModification | localizedDate) + ')') : '')}}
                    </label>
                  </div>
                }
                <ng-select [items]="workflows"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="nomDate"
                  placeholder="{{'GLOBAL.WORKFLOW' | translate}}"
                  name="selectWorkflow"
                  id="selectWorkflow"
                  [(ngModel)]="workflowSelectionne"
                  class="custom">
                </ng-select>
                @if (workflowInvalide) {
                  <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
                }
              </div>
              @if (erreurApi) {
                <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
              }

              <div class="btn-toolbar justify-content-between">
                <div class="btn-group" role="group">
                  <button type="submit" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
                  @if (projet?.tirs?.length == 0) {
                    <button type="button" class="btn btn-danger" (click)="modalConfirmSuppr.show()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
                  }
                </div>
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
                </div>
              </div>
            </form>
          </div>

          <div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="custom-overlay"></div>
                <div class="modal-body text-center">
                  <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
                  <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
                  <button type="button" class="btn btn-secondary" (click)="modalConfirmSuppr.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                </div>
              </div>
            </div>
          </div>

          <div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
            <div class="modal-dialog modal-sm">
              <div class="modal-content">
                <div class="custom-overlay"></div>
                <div class="modal-body text-center">
                  <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
                  <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
                  <button type="button" class="btn btn-secondary" (click)="hideModalConfirm()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
